import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  draft() {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 second timeout

    // Get the trix-editor controller to access the editor
    const trixEditorElement = this.element.querySelector('[data-controller~="trix-editor"]')
    const trixEditorController = this.application.getControllerForElementAndIdentifier(
      trixEditorElement,
      "trix-editor"
    )

    if (!trixEditorController) return

    const editor = trixEditorController.editorTarget.editor
    const form = this.formTarget
    const formData = new FormData(form)

    const body = formData.get("message_template[body]")
    const messageFormat = formData.get("message_template[message_format]") || "text"

    // Build a minimal payload for the drafts endpoint
    const draftData = new FormData()
    draftData.append("message_template[body]", body || "")
    draftData.append("message_template[message_format]", messageFormat)

    // Convert/sanitize via the drafts endpoint without saving the record
    fetch("/message-templates/drafts", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      },
      body: draftData,
      signal: controller.signal
    })
      .then(async (response) => {
        clearTimeout(timeoutId)
        let errorMessage = i18n.t("js.message_templates.drafts.errors.draft_failed")

        if (!response.ok) {
          errorMessage = this.getErrorMessage(response.status)
          throw new Error(errorMessage)
        }

        return response.json()
      })
      .then((data) => {
        // For message templates in text format we need to ensure we use the stripped version
        if (data.message_template?.message_format === "text") {
          const newBody = data.message_template?.body || data?.body
          if (newBody != null) {
            editor.loadHTML(newBody)
          }
        }
      })
      .catch((error) => {
        clearTimeout(timeoutId)

        if (error.name === "AbortError") {
          App.displayFlash(
            "danger",
            i18n.t("js.message_templates.drafts.errors.timeout")
          )
        } else if (error.name === "SyntaxError") {
          App.displayFlash(
            "danger",
            i18n.t("js.message_templates.drafts.errors.draft_failed")
          )
        } else {
          App.displayFlash(
            "danger",
            error.message || i18n.t("js.message_templates.drafts.errors.unexpected_error")
          )
        }
      })
  }

  getErrorMessage(status) {
    switch (status) {
      case 422:
        return i18n.t("js.message_templates.drafts.errors.validation_error")
      case 401:
        return i18n.t("js.message_templates.drafts.errors.session_expired")
      case 403:
        return i18n.t("js.message_templates.drafts.errors.permission_denied")
      case 500:
        return i18n.t("js.message_templates.drafts.errors.server_error")
      default:
        return i18n.t("js.message_templates.drafts.errors.draft_failed")
    }
  }
}
